const API_BASE_URL =
  (typeof process !== 'undefined' && (process as any).env?.NEXT_PUBLIC_API_URL) ||
  (import.meta as any)?.env?.VITE_API_URL ||
  'http://localhost:4000'

/**
 * POST /upload (apps/api/src/routes/salesdocs.ts) returns a path relative to
 * the API server, e.g. "/uploads/169...-file.png" - it's served as a static
 * file by the API, not by the frontend dev server or wherever the built
 * frontend is hosted, so rendering it as-is (`<img src="/uploads/...">`,
 * `link.href = fileUrl`) resolves against the wrong origin and 404s. Data
 * URLs and already-absolute URLs (http(s)://, blob:) pass through unchanged.
 */
export function resolveFileUrl(url?: string | null): string {
  if (!url) return ''
  if (/^(data:|https?:\/\/|blob:)/i.test(url)) return url
  return `${API_BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`
}
